import React, { forwardRef } from 'react';
import { InputGroup, Form, FloatingLabel } from 'react-bootstrap';

const TextFieldWithIcon = forwardRef(({ placeholder, icon, ...props }, ref) => {
    return (
        <InputGroup className='w-100 flex-nowrap'>
            <InputGroup.Text style={{ color: "#244da1", backgroundColor: "#91A6D0" }}>
                {icon}
            </InputGroup.Text>
            <FloatingLabel controlId="floatingInput" label={placeholder} className='w-100'>
                <Form.Control
                    ref={ref}
                    placeholder={placeholder}
                    aria-label={placeholder}
                    {...props}
                />
            </FloatingLabel>
        </InputGroup>
    );
});

export default TextFieldWithIcon;
